<template>
  <div id="app">
    <nav>
      <a href="/">Home</a> | <a href="/about">About</a> |
      <a href="/risk-app">app</a>
    </nav>
    <el-tree
      v-model="checkNodes"
      :data="data"
      show-checkbox
      node-key="id"
      @check-change="handleCheckChange"
      @check="handleCheck"
      ref="tree"
    >
    </el-tree>
    <el-button @click="getCheckedTree">get nodes</el-button>
    <router-view />
    <div id="sub-container"></div>
    <div v-for="item in arr" :key="item.value">
      <el-popover
        placement="right-end"
        title="标题"
        width="200"
        trigger="hover"
        content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
        :visible-arrow="false"
      >
        <el-button slot="reference" :ref="item.title">{{
          item.title
        }}</el-button>
      </el-popover>
      <textarea></textarea>
    </div>
    <div class="tabs-nav">
      <span class="tabs-nav-prev" @click="changeX(false)"
        ><i class="el-icon-arrow-left"></i
      ></span>
      <span class="tabs-nav-next" @click="changeX(true)"
        ><i class="el-icon-arrow-right"></i
      ></span>
      <div class="tabs-scroll">
        <div
          class="tabs-scroll-content"
          :style="{ transform: `translateX(${scrollX}px)` }"
        >
          <span
            v-for="(tab, index) in tabs"
            :key="index"
            :class="['tabs-tab', { active: activeIndex === index }]"
            @click="changeTab(index)"
          >
            {{ tab.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { start } from "qiankun";
import { registerApps } from "./qiankun/index";
import axios from "axios";
// import download from "downloadjs";
// import axios from "axios";
export default {
  data() {
    return {
      activeIndex: 0,
      scrollX: 0,
      checkNodes: [],
      arr: [
        { title: "test1", value: 1 },
        { title: "test2", value: 2 },
        { title: "test3", value: 3 },
        { title: "test4", value: 4 },
      ],
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1",
            },
            {
              id: 6,
              label: "二级 2-2",
            },
          ],
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      tabs: [
        { label: "tab1" },
        { label: "tab2" },
        { label: "tab3" },
        { label: "NEW Label1" },
        { label: "NEW Label2" },
        { label: "NEW Label3" },
        { label: "NEW Label4" },
        { label: "NEW Label5" },
        { label: "NEW Label6" },
        { label: "NEW Label7" },
      ],
    };
  },
  mounted() {
    if (!window.qiankunStarted) {
      window.qiankunStarted = true;
      registerApps();
      start({
        sandbox: {
          experimentalStyleIsolation: true, // 样式隔离
        },
      });
    }
    Object.keys(this.$refs).forEach((ref) => {
      console.log(this.$refs[ref]);
    });
    axios.interceptors.response.use(
      function (response) {
        console.log(response);
        // 对响应数据做点什么
        return response;
      },
      function (error) {
        // 对响应错误做点什么
        return Promise.reject(error);
      }
    );
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index;
    },
    changeX(isNext) {
      if (isNext) {
        this.scrollX -= 100;
      } else {
        if (this.scrollX === 0) return;
        this.scrollX += 100;
      }
    },
    handleDelNodes() {
      const leafNodes = this.$refs.tree.getCheckedNodes(true);
      const delNodes = this.$refs.tree.getCheckedNodes();
      leafNodes.forEach((node) => {
        const cur = delNodes.findIndex((i) => i.partId === node.partId);
        // 非叶子节点
        if (cur > -1) {
          delNodes[cur].child.length === 1 && delNodes.splice(1, cur);
        }
      });
    },
    /**
     * 获取 el-tree 选中的树形数组
     */
    getCheckedTree() {
      const url =
        "http://disc.static.szse.cn/download/disc/disk03/finalpage/2025-07-29/542bdbf2-a276-4800-926c-b89da2ce3e81.PDF?n=%E5%9B%BD%E4%BF%A1%E8%AF%81%E5%88%B8%EF%BC%9A%E5%9B%BD%E4%BF%A1%E8%AF%81%E5%88%B8%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E5%8F%91%E8%A1%8C%E8%82%A1%E4%BB%BD%E8%B4%AD%E4%B9%B0%E8%B5%84%E4%BA%A7%E6%9A%A8%E5%85%B3%E8%81%94%E4%BA%A4%E6%98%93%E6%8A%A5%E5%91%8A%E4%B9%A6%EF%BC%88%E8%8D%89%E6%A1%88%EF%BC%89%E6%91%98%E8%A6%81%EF%BC%88%E6%B3%A8%E5%86%8C%E7%A8%BF%EF%BC%89.PDF";
      // axios.post(url, { a: 1, b: 2 }).then(() => {
      //   false;
      //   // download(res.data);
      // });
      const a = document.createElement("a");
      // a.target = "_blank";
      a.style.display = "none";
      // a.download = "附件.pdf";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    flatArr(arr, total = []) {
      const res = arr.reduce((cur, pre) => {
        cur.push(pre.text);
        if (Array.isArray(pre.child)) {
          this.flatArr(pre.child, cur);
        }
        return cur;
      }, total);
      console.log(res);
    },
    handleUpload() {
      console.log(1);
      this.$router.push({ path: "/about" });
    },
    timestampReInit(startTimestamp, endTimestamp) {
      const dayTimestamp = 24 * 3600 * 1000;
      const timestampArr = [];
      for (let i = startTimestamp; i === endTimestamp; ) {
        timestampArr.push(i);
        i += dayTimestamp;
      }
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#sub-container {
  width: 100%;
  height: 400px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.tabs-nav {
  position: relative;
  border-bottom: 1px solid #ddd;
  padding: 0px 20px;
}
.tabs-tab {
  display: inline-block;
  padding: 8px 16px;
  cursor: pointer;
  background: none;
  border: none;
  outline: none;
}
.tabs-scroll {
  text-align: left;
  overflow: hidden;
}
.tabs-scroll-content {
  white-space: nowrap;
  transition: transform 0.3s ease-in-out;
}
.tabs-nav-prev {
  left: 0;
}
.tabs-nav-next {
  right: 0;
}
.tabs-nav-next,
.tabs-nav-prev {
  position: absolute;
  cursor: pointer;
  line-height: 44px;
  font-size: 12px;
  width: 20px;
  text-align: center;
}
.tabs-tab.active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}
</style>
